import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCustomerName } from '@/views/platformReport/api';
import { isNumber } from '@/utils';
import orderConsumeptionTrend from '@/views/platformReport/orderConsumptionTrend.vue';
export default {
  name: 'SameTypeHistoryOrder',
  props: {
    orderId: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pages: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    orderConsumeptionTrend: orderConsumeptionTrend
  },
  data: function data() {
    return {
      searchForm: {
        order_id: this.orderId,
        sort: ''
      },
      isSmall: false,
      trendParams: {},
      drawerTitle: '',
      drawerOrderId: '',
      drawer: false
    };
  },
  filters: {
    removeDecimal: function removeDecimal(value) {
      if (isNumber(value, true)) {
        return value + '%';
      }
      return value;
      return Math.round(value);
    }
  },
  mounted: function mounted() {
    this.isSmall = window.innerWidth <= 1440;
  },
  methods: {
    // 分页操作
    onChange: function onChange(val) {
      this.$emit('onChange', val);
    },
    sortChange: function sortChange(_ref) {
      var column = _ref.column,
        prop = _ref.prop,
        order = _ref.order;
      this.$emit('sortChange', {
        column: column,
        prop: prop,
        order: order
      });
    },
    jumpCustomer: function jumpCustomer(row) {
      var company_name = row.company_name,
        customer_id = row.customer_id;
      var src = "".concat(this.$store.state.user.domainName, "/#/platformConfig/customer/customerManagement?company_name=").concat(company_name, "&customer_id=").concat(customer_id);
      window.open(src, '_blank');
    },
    jumpDetail: function jumpDetail(row) {
      var src = '';
      src = "".concat(this.$store.state.user.domainName, "/#/order/orderDetails?order_id=").concat(row.id);
      window.open(src, '_blank');
    },
    watchInfo: function watchInfo(row) {
      var params = {
        customer_id: row.customer_id,
        role: '/count/order/index',
        order_id: row.id
      };
      getCustomerName(params).then(function (res) {
        row.company_name = res.data.company_name;
      });
    },
    onClickOrderId: function onClickOrderId(drawerOrderId) {
      var src = "".concat(this.$store.state.user.domainName, "/#/order/orderDetails?order_id=").concat(drawerOrderId);
      window.open(src, '_blank');
    },
    toTend: function toTend(row) {
      this.$emit('emitToTend', row);
    },
    copyUrl: function copyUrl() {
      this.$message.success('复制成功');
    }
  }
};